import AboutSection from "../components/AboutUs2/AboutSection"
import StrategySection from "../components/AboutUs2/StrategySection"
import TeamMembers from "../components/AboutUs2/TeamMembers"
import FindQuestion from "../components/ContactUs/FindQuestion"
import LetterBox from "../components/ContactUs/LetterBox"
import Collaborations from "../components/Home2/Collaborations"
import Testimonials from "../components/Home2/Testimonials"

const AboutUs2 = () => {
  return (
    <>
    <AboutSection/>
    <Collaborations/>
    <StrategySection/>
    <Testimonials/>
    <TeamMembers/>
    <FindQuestion/>
    <LetterBox/>
    </>
  )
}

export default AboutUs2